var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.236,
    height: 20.237,
    viewBox: "0 0 20.236 20.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-edit",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_268",
    "data-name": "Grupo 268",
    transform: "translate(0 1.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_267",
    "data-name": "Grupo 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    "data-name": "Trazado 154",
    d: "M1748.973,166.844a.723.723,0,0,0-.723.722v7.228a.722.722,0,0,1-.722.723h-13.009a.723.723,0,0,1-.723-.723V160.339a.723.723,0,0,1,.723-.723h8.673a.722.722,0,0,0,0-1.445h-8.673a2.168,2.168,0,0,0-2.168,2.168v14.454a2.168,2.168,0,0,0,2.168,2.168h13.009a2.169,2.169,0,0,0,2.168-2.168v-7.228A.723.723,0,0,0,1748.973,166.844Z",
    transform: "translate(-1732.35 -158.171)",
    fill: "#0050c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_270",
    "data-name": "Grupo 270",
    transform: "translate(4.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_269",
    "data-name": "Grupo 269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    "data-name": "Trazado 155",
    d: "M1750.144,158.08a2.765,2.765,0,0,0-3.913,0l-9.52,9.52a.746.746,0,0,0-.175.282l-1.445,4.336a.722.722,0,0,0,.457.914.726.726,0,0,0,.457,0l4.336-1.445a.739.739,0,0,0,.282-.175l9.52-9.52A2.767,2.767,0,0,0,1750.144,158.08Zm-1.021,2.892-9.4,9.395-2.806.938.933-2.8,9.4-9.4a1.321,1.321,0,1,1,1.87,1.867Z",
    transform: "translate(-1735.054 -157.269)",
    fill: "#0050c4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.b35e3f011552cc183ad3a327ea07f496.svg";
export { ForwardRef as ReactComponent };